<div mat-dialog-title>
  <h2>Attachments — {{ productName }}</h2>
  <span class="apply-hint">Changes are stored when you Save the profile</span>
  <button mat-button type="button" (click)="close()">Close</button>
</div>
<div mat-dialog-content>
  <tc-offer-attachments
    [fileIds$]="fileIds$"
    [restoreFileInfos$]="restoreFileInfos$"
    [isVisible]="true"
    [readonly]="false"
    [suffixControl]="true"
    [productPicControl]="true"
    [techSpecControl]="true"
    [archiveControl]="true"
    [suffixes]="suffixes$ | async"
    [productPicFileId]="productPicFileId"
    [techSpecFileId]="techSpecFileId"
    (valueChange)="onFilesChange($event)"
  ></tc-offer-attachments>
</div>
